// extracted by mini-css-extract-plugin
export var cardIcon = "_9p-4";
export var checkboxCard = "_9p-0";
export var checkboxCardSelected = "_9p-3";
export var disabled = "_9p-1";
export var outerBorder = "_9p-2";
export var spacerMedium = "_9p-7";
export var spacerSmall = "_9p-6";
export var spacerXsmall = "_9p-5";